module.exports = __webpack_public_path__ + "media/app/assets/specializations/monk/windwalker-1e2dda905012068adf5780bbd6c7d4a4.png";